import { useSelector } from 'react-redux';

import { getTheme, mergeStyleSets } from '@fluentui/react';
import { RootState } from '../../../../../redux/application/redux-store';

interface IIAICalendarHolidaysClassNames {
    calloutContainer: string;
    calloutBeakCurtain: string;
    selected: string;
}

export const useClassNames = (): IIAICalendarHolidaysClassNames => {
    const applicationTheme = getTheme();

    const iaiSystem = useSelector((state: RootState) => state.system);

    return mergeStyleSets({
        calloutContainer: {
            padding: 20,
            width: 500,
            maxWidth: '90%'
        },
        calloutBeakCurtain: {
            background: iaiSystem.theme === 'light'
                ? applicationTheme.palette.themeLighter
                : applicationTheme.palette.themeTertiary
        },
        selected: {
            backgroundColor: applicationTheme.palette.themeTertiary,
            borderRadius: '100% !important',
            color: iaiSystem.theme === 'light' ? `${applicationTheme.palette.white} !important` : `${applicationTheme.palette.black} !important`,
            selectors: {
                ':hover': {
                    backgroundColor: applicationTheme.palette.themeTertiary,
                },
                ':focus': {
                    backgroundColor: applicationTheme.palette.themeTertiary,
                },
                ':active': {
                    backgroundColor: applicationTheme.palette.themeTertiary,
                }
            }
        },
    });
}